import { Input } from "reactstrap";

function BasicInput({
    placeholder = "label",
    value,
    disabled,
    onChange,
    type = "text"
}) {
    return (
        <>
        <Input
            className="text-center rounded-pill size-bg"
            name= {placeholder}
            placeholder={placeholder}
            type={type}
            value={value}
            disabled={disabled}
            onChange={onChange} />
        </>
    )
}

export default BasicInput